import { usePathname } from 'next/navigation';
import { useMutation, UseMutationResult } from 'react-query';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

interface UseMutationCreatePaymentRequestData {
  appUrl: string;
  dynamicJavascriptUrl: string;
  paymentRequestId: string;
  result: string;
  statusCode: number;
  url: string;
}

interface UseMutationCreatePaymentRequestError {
  errors: any;
  message?: string;
}

interface UseMutationCreatePaymentRequestVariables {
  amount: string;
  bookingNumber: string;
  customerComment: string;
  customerEmail: string;
  customerName: string;
  paymentMethod: string;
}

const useMutationCreatePaymentRequest = () => {
  const pathname = usePathname();
  const locale = getLocale();

  const mutation: UseMutationResult<
    UseMutationCreatePaymentRequestData,
    UseMutationCreatePaymentRequestError,
    UseMutationCreatePaymentRequestVariables
  > = useMutation(
    async variables => {
      const fetchResponse = await fetch('/api/create-payment-request', {
        body: JSON.stringify({
          ...variables,
          path: pathname,
        }),
        headers: {
          ['Accept-Language']: getCulture(locale),
          ['Content-Type']: 'application/json',
        },
        method: 'POST',
      })
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('content.useMutationCreatePaymentRequest', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      onError: async error => error,
    },
  );

  return mutation;
};

export default useMutationCreatePaymentRequest;
